import React from 'react';
import { useOutletContext } from 'react-router-dom';
import Focus from '../../components/Focus';

export default function FocusPage() {
  const ctx = useOutletContext();
  return <Focus {...ctx} />;
}
